module.exports = __webpack_public_path__ + "img/event-3@2x.e58e0f15.png";